import { clearIdentityCache } from '@/platform/http/requestInterceptors'
import { clearPostSignupAuthUserIdBridge } from '@/utilities/auth/postSignupAuthUserIdBridge'
import { clearTrustedIdentityScopesCache } from '@/utilities/auth/trustedIdentityScopes'

/**
 * Clears the cached x-user-identity. Call during logout so the next user does not
 * receive a stale identity.
 */
export const clearAuthUserId = (): void => {
  if (globalThis.window === undefined) return

  clearIdentityCache()
  clearTrustedIdentityScopesCache()
  clearPostSignupAuthUserIdBridge()
  try {
    localStorage.removeItem('authUserId')
  } catch {
    // Ignore storage cleanup failures in non-browser or restricted contexts.
  }
}
